export default {"src":"/_next/static/media/back.6a4ebcb4.svg","height":24,"width":24};